import { Link } from "gatsby";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { GiHamburgerMenu } from "react-icons/gi";

import "./header.css";

const Header = ({ onHideNav, onShowNav, showNav, siteTitle, headerNode }) => {
  const [isMobileOn, setIsMobileOn] = useState(false);
  const handleNavBar = () => {
    console.log("handleNavBar");
    if (!isMobileOn) {
      setIsMobileOn(true);
    } else {
      setIsMobileOn(false);
    }
  };
  return (
    <Box
      className="headerBox"
      pl={{ xs: 2, sm: 5, md: 15 }}
      pr={{ xs: 2, sm: 5, md: 15 }}
      pt={{ xs: 1, sm: 1, md: 1 }}
    >
      <Grid container spacing={4}>
        <Grid item md={3} sm={10} xs={10}>
          <img src="/ttk_logo.png" className="logosite" />
        </Grid>

        <Grid
          item
          md={9}
          sm={12}
          xs={12}
          className={isMobileOn ? "headerTabs" : "headerTabsOff"}
        >
          <Grid container spacing={0}>
            {headerNode.headerTab &&
              headerNode.headerTabItems.map((item, index) => {
                return (
                  <Grid
                    item
                    md={2}
                    sm={12}
                    xs={12}
                    key={item._key}
                    className="gridTabItem"
                  >
                    <a href={item.itemURL} className={`tabItem`}>
                      {item.itemTitle}
                    </a>
                  </Grid>
                );
              })}
            {headerNode.buttonTab && headerNode.buttonText ? (
              <Grid item md={2} sm={12} xs={12} className="subscribeBtnGrid">
                <button className="subscribeBtn">
                  {headerNode.buttonText}
                </button>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
        {headerNode.headerTab || headerNode.buttonTab ? (
          <Grid item md={0} sm={2} xs={2} className="hamburgerMobile">
            <GiHamburgerMenu onClick={handleNavBar} />
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
};

export default Header;
